import { render, staticRenderFns } from "./FavouriteEmployees.vue?vue&type=template&id=3eb850b4"
import script from "./FavouriteEmployees.vue?vue&type=script&lang=js"
export * from "./FavouriteEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports